import { render } from "./ConstructionForm.vue?vue&type=template&id=5a805f8e"
import script from "./ConstructionForm.vue?vue&type=script&lang=js"
export * from "./ConstructionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__